import {
  Briefcase,
  Cpu,
  Gamepad2,
  Share2,
} from "lucide-react";
import {
  HarmonySearchMd,
  HarmonyShoppingCart,
  HarmonySparkles,
} from "@/components/icons/harmony-icons-inline";
import type {
  CommerceParams,
  ModelsParams,
  ModuleInstance,
} from "../registry/types";

/**
 * Kayıtlı instance'lar — sidebar/dashboard sırası bu dizinin sırasıdır.
 *
 * `theme.hue` OKLCH hue; `--primary` ve türevleri Faz 1'de bundan üretilir.
 * `subdomain` eşleşince instance root'a mount edilir (bkz. registry `hostModule`).
 */

export const fashionModule: ModuleInstance<CommerceParams> = {
  id: "fashion",
  blueprint: "commerce",
  basePath: "/fashion",
  subdomain: "shop",
  nameKey: "modules.fashion",
  descriptionKey: "modules.descriptions.fashion",
  icon: HarmonyShoppingCart,
  status: "active",
  theme: { hue: 330 },
  params: { vertical: "fashion", features: { wardrobe: true } },
};

/**
 * Fashion ile aynı motor, farklı katalog. Backend `vertical=technology`
 * filtresini tanıyınca ve GrowthBook bayrağı açılınca `active` olur.
 * Route'ları şimdiden mount; dev'de hub kartından açılıp prova edilebilir
 * (bkz. module-hub `canOpenModule`). Katalog bağlanana kadar fashion verisi
 * görünür — metinler ve gardırop kapısı instance'a göre farklıdır.
 */
export const technologyModule: ModuleInstance<CommerceParams> = {
  id: "technology",
  blueprint: "commerce",
  basePath: "/technology",
  subdomain: "tech",
  nameKey: "modules.technology",
  descriptionKey: "modules.descriptions.technology",
  icon: Cpu,
  status: "soon",
  theme: { hue: 200 },
  params: { vertical: "technology", features: { wardrobe: false } },
};

export const modelsModule: ModuleInstance<ModelsParams> = {
  id: "models",
  blueprint: "models",
  basePath: "/models",
  nameKey: "modules.models",
  descriptionKey: "modules.descriptions.models",
  icon: HarmonySparkles,
  status: "active",
  theme: { hue: 273.6 }, // = mevcut indigo (#6172f3); models sayfaları bugünkü gibi görünür
  params: {},
};

export const deepSearchModule: ModuleInstance = {
  id: "deep-search",
  basePath: "/deep-search",
  nameKey: "modules.deepSearch",
  descriptionKey: "modules.descriptions.deepSearch",
  icon: HarmonySearchMd,
  status: "soon",
  theme: { hue: 160 },
};

export const socialModule: ModuleInstance = {
  id: "social",
  basePath: "/social",
  nameKey: "modules.social",
  descriptionKey: "modules.descriptions.social",
  icon: Share2,
  status: "soon",
  theme: { hue: 30 },
};

export const businessModule: ModuleInstance = {
  id: "business",
  basePath: "/business",
  nameKey: "modules.business",
  descriptionKey: "modules.descriptions.business",
  icon: Briefcase,
  status: "soon",
  theme: { hue: 240 },
};

export const entertainmentModule: ModuleInstance = {
  id: "entertainment",
  basePath: "/entertainment",
  nameKey: "modules.entertainment",
  descriptionKey: "modules.descriptions.entertainment",
  icon: Gamepad2,
  status: "soon",
  theme: { hue: 300 },
};

export const MODULE_INSTANCES: ReadonlyArray<ModuleInstance> = [
  fashionModule as ModuleInstance,
  socialModule,
  modelsModule as ModuleInstance,
  deepSearchModule,
  technologyModule as ModuleInstance,
  businessModule,
  entertainmentModule,
];
